import React, { useState, Suspense, lazy } from 'react';
import './App.css';
import HeroHeader from './components/HeroHeader';
import QuoteSection from './components/QuoteSection';
import CountdownTimer from './components/CountdownTimer';
import InvitationVideo from './components/InvitationVideo';

const CoupleIntro = lazy(() => import('./components/CoupleIntro'));
const WeddingDetails = lazy(() => import('./components/WeddingDetails'));
const Timeline = lazy(() => import('./components/Timeline'));
const CoupleNote = lazy(() => import('./components/CoupleNote'));
const RsvpSection = lazy(() => import('./components/RsvpSection'));
const PhotoGallery = lazy(() => import('./components/PhotoGallery'));
const Footer = lazy(() => import('./components/Footer'));

function App() {
  const [showVideo, setShowVideo] = useState(true);

  const handleVideoEnd = () => {
    setShowVideo(false);
  };

  return (
    <div className="App">
      {showVideo && <InvitationVideo onVideoEnd={handleVideoEnd} />}
      <div className={`main-content ${showVideo ? 'hidden' : 'visible'}`}>
        <HeroHeader />
        <QuoteSection />
        <CountdownTimer />
        <Suspense fallback={<div>Loading...</div>}>
          <CoupleIntro />
        </Suspense>
        <div id="details">
          <Suspense fallback={<div>Loading...</div>}>
            <WeddingDetails />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
            <Timeline />
          </Suspense>
        </div>
        <Suspense fallback={<div>Loading...</div>}>
          <CoupleNote />
        </Suspense>
        <div id="rsvp">
          <Suspense fallback={<div>Loading...</div>}>
            <RsvpSection />
          </Suspense>
        </div>
        <div id="gallery">
          <Suspense fallback={<div>Loading...</div>}>
            <PhotoGallery />
          </Suspense>
        </div>
        <Suspense fallback={<div>Loading...</div>}>
          <Footer />
        </Suspense>
      </div>
    </div>
  );
}

export default App;